import { normalizeToolName } from './tool-config';

export const formatToolInput = (
  toolName: string,
  args: Record<string, unknown>,
): string => {
  if (!args || Object.keys(args).length === 0) {
    return '';
  }

  const normalizedName = normalizeToolName(toolName);

  switch (normalizedName) {
    case 'coder':
    case 'sub-agent-coder':
      return args.query ? String(args.query) : '';
    case 'todo-write':
      return '';
    case 'sub-agent-intelligence':
      return args.query ? String(args.query) : '';
    case 'navigate-web':
      return args.query ? String(args.query) : '';
    case 'search-endpoints':
      return args.query ? String(args.query) : '';
    case 'get-endpoint-details':
    case 'get-authentication-details':
      return '';
    default:
      return '';
  }
};

export const formatToolOutput = (
  toolName: string,
  output: string | undefined,
): string => {
  if (!output) return '';

  const normalizedName = normalizeToolName(toolName);

  try {
    const parsed = JSON.parse(output);

    return `\`\`\`json\n${JSON.stringify(parsed, null, 2)}\n\`\`\``;
  } catch {
    if (
      normalizedName === 'coder' ||
      normalizedName === 'python' ||
      normalizedName === 'python-tool' ||
      normalizedName === 'sub-agent-coder' ||
      output.includes('```')
    ) {
      if (output.includes('```')) {
        return output;
      }

      return `\`\`\`\n${output}\n\`\`\``;
    }

    if (normalizedName === 'sub-agent-intelligence') {
      return output;
    }

    return output;
  }
};
